import React, { useState } from 'react'
import { Container, Row, Col } from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import Header from '../components/Header'
import DistributorsCreateCard from '../components/distributors/DistributorsCreateCard'
import apiDistributorService from '../services/apiDistributorService'
import '../styles/FormView.css'

function DistributorsAddView() {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({ name: '' })
  const [errors, setErrors] = useState({})
  const [submitted, setSubmitted] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')

  const handleInputChange = (event) => {
    const { name, value } = event.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: '',
      }))
    }
  }

  const validateForm = () => {
    const newErrors = {}
    if (!formData.name.trim()) {
      newErrors.name = 'El nombre es requerido'
    }
    return newErrors
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setSubmitted(true)
    setErrorMessage('')
    setSuccessMessage('')

    const newErrors = validateForm()
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    setIsSaving(true)
    try {
      await apiDistributorService.createDistributor({ name: formData.name })
      setSuccessMessage('Distribuidor creado correctamente.')
      setTimeout(() => navigate('/distributors'), 600)
    } catch (error) {
      const message = error?.body?.message || 'No se pudo registrar el distribuidor.'
      setErrorMessage(message)
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <>
      <Header />
      <Container fluid className="form-container">
        <Container>
          <div className="form-header">
            <h1>Distribuidores</h1>
          </div>
          <Row className="justify-content-center">
            <Col xs={12} md={8} lg={6}>
              <DistributorsCreateCard
                formData={formData}
                errors={errors}
                submitted={submitted}
                isSaving={isSaving}
                errorMessage={errorMessage}
                successMessage={successMessage}
                onInputChange={handleInputChange}
                onSubmit={handleSubmit}
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  )
}

export default DistributorsAddView
